import React, { Component } from 'react';
import * as auth from "../Authentication";
import './login.css';

export class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);
        this.state = {
            companyName: "",
            emailStatus: "idle" // idle | sending | sent — drives the "email me the code" button
        };
    }

    componentDidMount() {
        this.getComponentData();
    } 

    authenticateLogin = function (e) {
        e.preventDefault();
    }

    handleLogin(event) {
        auth.authenticateLogin(document.getElementById("login").children[0]);
        event.preventDefault();
    }

    handleChangePassword(event) {
        auth.verifyPasswordUpdate(document.getElementById("changePassword").children[0]);
        event.preventDefault();
    }

    handleForgotPassword(event) {
        auth.updateDisplayForm("login", "forgotPasswordRequest");
        event.preventDefault();
    }

    handleTwoFactor(event) {
        auth.verifyTwoFactorCode(document.getElementById("twoFactor").children[0])
        event.preventDefault();
    }

    resendTwoFactorCode(event) {
        auth.resendTwoFactorCode();
        event.preventDefault();
    }

    emailTwoFactorCode = async (event) => {
        event.preventDefault();
        if (this.state.emailStatus === "sending") return;

        this.setState({ emailStatus: "sending" });
        try {
            await auth.sendTwoFactorCodeByEmail();
        }
        catch (e) { /* auth surfaces any error in #twoFactorError */ }
        this.setState({ emailStatus: "sent" });

        // Re-enable after a short cooldown so the user can request another email
        setTimeout(() => this.setState({ emailStatus: "idle" }), 6000);
    }

    handleForgotPasswordRequest(event) {
        auth.forgotPasswordRequest(document.getElementById("forgotPasswordRequest").children[0])
        event.preventDefault();
    }

    handleForgotPasswordChange(event) {
        auth.forgotPasswordChange(document.getElementById("forgotPasswordChange").children[0])
        event.preventDefault();
    }

    render() {
        let companyName = this.state.companyName;

        // "Email me the code" button reflects send progress so the click is never silent
        let emailStatus = this.state.emailStatus;
        let emailBtnClass = "btn btn-outline-primary email-code-btn";
        let emailBtnContent;
        let emailBtnDisabled = false;
        if (emailStatus === "sending") {
            emailBtnContent = <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Sending…</>;
            emailBtnDisabled = true;
        }
        else if (emailStatus === "sent") {
            emailBtnContent = <><i className="fa fa-check-circle" aria-hidden="true"></i> Code sent — check your email</>;
            emailBtnClass += " email-code-btn--sent";
            emailBtnDisabled = true;
        }
        else {
            emailBtnContent = <><i className="fa fa-envelope" aria-hidden="true"></i> Email me the code instead</>;
        }
        let emailButton = <button type="button" className={emailBtnClass} onClick={this.emailTwoFactorCode} disabled={emailBtnDisabled} aria-live="polite">{emailBtnContent}</button>;

        return (
            <div className="container">
                <div className="form-step" id="login">
                    <form onSubmit={this.handleLogin}>
                        <input type="hidden" name="company" value={companyName} />

                        <p className="error-message" id="loginError" role="alert" aria-live="assertive" />

                        <div className="input-container form-fields">
                            <i className="fa fa-envelope icon" aria-hidden="true" />
                            <label htmlFor="email" className="sr-only">Username</label>
                            <input type="text" name="email" id="email" required="required" aria-required="true" aria-describedby="loginError" className="form-control input-field" placeholder="Username" autoComplete="username" />
                        </div>

                        <div className="input-container form-fields">
                            <i className="fa fa-lock icon" aria-hidden="true"></i>
                            <label htmlFor="password" className="sr-only">Password</label>
                            <input type="password" name="password" id="password" required="required" aria-required="true" aria-describedby="loginError" className="form-control input-field" placeholder="Password" autoComplete="current-password" />
                        </div>
                        {
                            <p className="assist-link">
                                <a href="#" onClick={this.handleForgotPassword}>Don't remember your password?</a>
                            </p>
                        }

                        <input className="btn btn-primary form-fields-login" type="submit" name="submit" value="Log In" />
                    </form>
                </div>

                <div className="form-step" id="changePassword" style={{ display: "none" }}>
                    <form onSubmit={this.handleChangePassword}>
                        <input type="hidden" name="userId" id="changePasswordUserId" value="0" />
                        <input type="hidden" name="company" value={companyName} />

                        <p className="error-message" id="changePasswordError" role="alert" aria-live="assertive"></p>

                        <div className="input-container form-fields">
                            <i className="fa fa-lock icon" aria-hidden="true"></i>
                            <label htmlFor="oldPassword" className="sr-only">Old Password</label>
                            <input type="password" name="oldPassword" id="oldPassword" required="required" aria-required="true" aria-describedby="changePasswordError" className="form-control input-field" placeholder="Old Password" autoComplete="current-password" />
                        </div>

                        <div className="input-container form-fields">
                            <i className="fa fa-lock icon" aria-hidden="true"></i>
                            <label htmlFor="newPassword" className="sr-only">New Password</label>
                            <input type="password" name="newPassword" id="newPassword" required="required" aria-required="true" aria-describedby="changePasswordError" className="form-control input-field" placeholder="New Password" minLength="8" maxLength="20" autoComplete="new-password" />
                        </div>

                        <div className="input-container form-fields">
                            <i className="fa fa-check-circle icon" aria-hidden="true"></i>
                            <label htmlFor="confirmPassword" className="sr-only">Confirm Password</label>
                            <input type="password" name="confirmPassword" id="confirmPassword" required="required" aria-required="true" aria-describedby="changePasswordError" onInput={(event) => { auth.matchPassword(event.target) }} className="form-control input-field" placeholder="Confirm Password" autoComplete="new-password" />
                        </div>

                        <p className="assist-link"></p>

                        <input className="btn btn-primary form-fields-login" type="submit" name="submit" value="Log In" />
                    </form>
                </div>

                <div className="form-step" id="twoFactor" style={{ display: "none" }}>
                    <form onSubmit={this.handleTwoFactor}>
                        <input type="hidden" name="userId" id="twoFactorUserId" value="0" />
                        <input type="hidden" name="company" value={companyName} />

                        <p className="error-message" id="twoFactorError" role="alert" aria-live="assertive"></p>

                        <label htmlFor="code" className="input-label">Enter the verification code that was sent to you below.</label>
                        <div className="input-container form-fields">
                            <i className="fa fa-commenting icon" aria-hidden="true"></i>
                            <input type="number" min="100000" max="999999" name="code" id="code" required="required" aria-required="true" aria-describedby="twoFactorError" className="form-control input-field" placeholder="######" />
                        </div>

                        <input className="btn btn-primary form-fields-login" type="submit" name="submit" value="Confirm" />

                        <div className="two-factor-alt">
                            {emailButton}
                        </div>

                        <p className="assist-link resend-link">
                            Didn't get it? <a href="#" onClick={this.resendTwoFactorCode}>Resend code</a>
                        </p>
                    </form>
                </div>

                <div className="form-step" id="forgotPasswordRequest" style={{ display: "none" }}>
                    <form onSubmit={this.handleForgotPasswordRequest}>
                        <input type="hidden" name="company" value={companyName} />

                        <p className="error-message" id="forgotPwRequestError" role="alert" aria-live="assertive"></p>

                        <div className="input-container">
                            <i className="fa fa-envelope icon" aria-hidden="true"></i>
                            <label htmlFor="forgotPasswordEmail" className="sr-only">Username</label>
                            <input type="text" name="email" id="forgotPasswordEmail" required="required" aria-required="true" aria-describedby="forgotPwRequestError" className="form-control input-field" placeholder="Username" autoComplete="username" />
                        </div>

                        <input className="btn btn-primary form-fields-login" type="submit" name="submit" value="Submit" />

                        <p className="assist-link">
                            <a href="/" onClick={(event) => { auth.updateDisplayForm("forgotPasswordRequest", "login"); event.preventDefault(); }} >Back to Login</a>
                        </p>
                    </form>
                </div>

                <div className="form-step" id="forgotPasswordChange" style={{ display: "none" }}>
                    <form onSubmit={this.handleForgotPasswordChange}>
                        <input type="hidden" name="email" id="forgotPasswordChangeEmail" value="" />
                        <input type="hidden" name="company" value={companyName} />

                        <p className="error-message" id="forgotPwChangeError" role="alert" aria-live="assertive"></p>

                        <label htmlFor="forgotPwCode" className="input-label">Enter the number that has been texted to your cell phone below.</label>
                        <div className="input-container">
                            <i className="fa fa-commenting icon" aria-hidden="true"></i>
                            <input type="number" min="100000" max="999999" name="code" id="forgotPwCode" required="required" aria-required="true" aria-describedby="forgotPwChangeError" className="form-control input-field" placeholder="######" />
                        </div>

                        <div className="input-container">
                            <i className="fa fa-lock icon" aria-hidden="true"></i>
                            <label htmlFor="forgotNewPassword" className="sr-only">New Password</label>
                            <input name="password" type="password" id="forgotNewPassword" required="required" aria-required="true" aria-describedby="forgotPwChangeError" className="form-control input-field" placeholder="New Password" minLength="8" maxLength="20" autoComplete="new-password" />
                        </div>

                        <div className="input-container">
                            <i className="fa fa-check-circle icon" aria-hidden="true"></i>
                            <label htmlFor="forgotConfirmPassword" className="sr-only">Confirm Password</label>
                            <input type="password" name="confirmPassword" id="forgotConfirmPassword" required="required" aria-required="true" aria-describedby="forgotPwChangeError" onInput={(event) => { auth.matchNewPassword(event.target) }} className="form-control input-field" placeholder="Confirm Password" autoComplete="new-password" />
                        </div>

                        <input className="btn btn-primary form-fields-login" type="submit" name="submit" value="Submit" />

                        <p className="assist-link">
                            <a href="/" onClick={(event) => { auth.updateDisplayForm("forgotPasswordChange", "login"); event.preventDefault(); }}>Back to Login</a>
                        </p>
                    </form>
                </div>
            </div>
        );
    }

    async getComponentData() {
        const data = await auth.getCompanyName();
        this.setState({
            companyName: data
        });
    }
}
